interface Props {
    color?: string;
    scale?: number;
}

const Arc = ({ color = 'black', scale = 1 }: Props) => {
    return (
        <svg
            width="100%"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 500 ${30 * scale}`}
        >
            <g transform={`scale(1, ${scale})`}>
                <path fill={color} d="M0.000244141 30H500C500 30 407 0 250 0C93.0005 0 0.000244141 30 0.000244141 30Z"/>
            </g>
        </svg>

    )
}

export default Arc;
